import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { HistoriqueComponent } from '../historique/historique.component';
import { Organization } from 'src/app/models/organization.model';
import { GumOrganizationsService } from 'src/app/services/gumservices/gum-organizations.service';

@Component({
  selector: 'app-dashboard',
  imports: [MatCardModule, HistoriqueComponent],
  templateUrl: './dashboard.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent implements OnInit {
  private organizationsService = inject(GumOrganizationsService);

  currentOrganization: Organization | null = null;

  ngOnInit(): void {
    // Initialisation au chargement
    this.currentOrganization =
      this.organizationsService.getCurrentOrganization();

    // Écoute des changements
    this.organizationsService.currentOrganizationChange$.subscribe((org) => {
      this.currentOrganization = org;
      if (org) {
        this.loadDataForOrganization(org);
      }
    });

    // Chargement initial
    if (this.currentOrganization) {
      this.loadDataForOrganization(this.currentOrganization);
    }
  }

  loadDataForOrganization(org: Organization | null): void {
    if (!org) return;
  }
}
